/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from "react";
import "./AdminDSR.css";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";

const EmployeeDSRTab = ({
  // filters
  dsrFilters,
  setDsrFilters,
  dsrProjects,
  dsrEmployees,
  fetchDsrEmployees,
  fetchDsrProjects,
  fetchEmployeeDsr,
  handleDsrReset,

  // table data
  employeeDsrData,

  // edit modal
  showModal,
  modalType,
  closeModal,
  formData,
  setFormData,
  projects,
  handleUpdateTask,

  // delete modal
  showDeleteModal,
  setShowDeleteModal,
  deleteId,
  setDeleteId,
  deleteProjectName,
  setDeleteProjectName,
  handleDeleteConfirm,
  handleDeleteCancel,

  // open modal
  openModal,
}) => {
  return (
    <>
      <div className="filters-section-AdminDSR">
        <div className="filter-group-AdminDSR">
          <label>From Date</label>
          <input
            type="date"
            className="date-input-AdminDSR"
            value={dsrFilters.fromDate}
            onChange={(e) =>
              setDsrFilters({
                ...dsrFilters,
                fromDate: e.target.value,
                toDate: "",
              })
            }
          />
        </div>

        <div className="filter-group-AdminDSR">
          <label>To Date</label>
          <input
            type="date"
            className="date-input-AdminDSR"
            value={dsrFilters.toDate}
            disabled={!dsrFilters.fromDate}
            min={dsrFilters.fromDate}
            onChange={(e) =>
              setDsrFilters({
                ...dsrFilters,
                toDate: e.target.value,
              })
            }
          />
        </div>

        <div className="filter-group-AdminDSR">
          <label>Select Project</label>
          <select
            className="select-dropdown-AdminDSR"
            value={dsrFilters.projectId}
            onChange={(e) => {
              const projectId = e.target.value;
              // FIX: Only update projectId, keep userId intact.
              // Refetch employees filtered by this project but preserve current userId selection.
              setDsrFilters((prev) => ({ ...prev, projectId }));
              fetchDsrEmployees(projectId);
            }}
          >
            <option value="">Select</option>
            {dsrProjects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group-AdminDSR">
          <label>Select Employee</label>
          <select
            className="select-dropdown-AdminDSR"
            value={dsrFilters.userId}
            onChange={(e) => {
              const userId = e.target.value;
              setDsrFilters((prev) => ({ ...prev, userId }));
              fetchDsrProjects(userId);
            }}
          >
            <option value="">Select</option>
            {dsrEmployees.map((emp) => (
              <option key={emp.id} value={emp.id}>
                {emp.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className="search-button-AdminDSR"
            onClick={fetchEmployeeDsr}
          >
            Search
          </button>

          <button
            className="cancel-button-AdminDSR"
            onClick={handleDsrReset}
          >
            Reset
          </button>
        </div>
      </div>

      <div className="table-in-all-emplyee-AdminDSR">
        <table className="table-main-AdminDSR">
          <thead className="thead-main-AdminDSR">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Employee</th>
              <th>Project Name</th>
              <th>Task</th>
              <th>Hour</th>
              <th>Edit / Delete</th>
            </tr>
          </thead>
          <tbody className="tbody-main-AdminDSR">
            {employeeDsrData.length > 0 ? (
              employeeDsrData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.employee}</td>
                  <td>{item.project}</td>
                  <td>{item.task}</td>
                  <td>{item.hours}</td>
                  <td className="action-buttons-AdminDSR">
                    <button
                      className="edit-icon-button-AdminDSR"
                      onClick={() => openModal("editDSR", item)}
                    >
                      <FiEdit2 />
                    </button>
                    <button
                      className="delete-icon-button-AdminDSR"
                      onClick={() => {
                        setDeleteId(item.id);
                        setDeleteProjectName("");
                        setShowDeleteModal(true);
                      }}
                    >
                      <FiTrash2 />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">No record found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && modalType === "editDSR" && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Edit DSR</h3>
              <button onClick={closeModal} className="close-button-AdminDSR">
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-AdminDSR">
              <div className="form-row-AdminDSR">
                <div className="form-group-AdminDSR">
                  <label>Date *</label>
                  <input
                    type="date"
                    value={formData.date || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, date: e.target.value })
                    }
                  />
                </div>

                <div className="form-group-AdminDSR">
                  <label>Project *</label>
                  <select
                    value={formData.projectId || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, projectId: e.target.value })
                    }
                  >
                    <option value="">Select</option>
                    {projects.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row-AdminDSR">
                <div className="form-group-AdminDSR">
                  <label>Employee *</label>
                  <input
                    type="text"
                    value={formData.employeeName || ""}
                    readOnly
                  />
                </div>

                <div className="form-group-AdminDSR">
                  <label>Hours *</label>
                  <input
                    type="number"
                    value={formData.hours || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, hours: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="form-row-AdminDSR">
                <div className="form-group-AdminDSR">
                  <label>Minutes *</label>
                  <input
                    type="number"
                    value={formData.minutes || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, minutes: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="form-group-AdminDSR">
                <label>Task Detail *</label>
                <textarea
                  rows="4"
                  value={formData.task || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, task: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="modal-footer-AdminDSR">
              <button
                className="save-button-AdminDSR"
                onClick={handleUpdateTask}
              >
                UPDATE
              </button>
              <button className="cancel-button-AdminDSR" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-delete-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Confirm Delete</h3>
              <button
                onClick={handleDeleteCancel}
                className="close-button-AdminDSR"
              >
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-AdminDSR">
              <p className="delete-confirm-text-AdminDSR">
                Are you sure you want to delete this record?
              </p>
            </div>

            <div className="modal-footer-AdminDSR">
              <button
                className="save-button-AdminDSR"
                onClick={handleDeleteConfirm}
                style={{ backgroundColor: "#dc3545" }}
              >
                Yes, Delete
              </button>

              <button
                className="cancel-button-AdminDSR"
                onClick={handleDeleteCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmployeeDSRTab;
